/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  DeleteApiV1LocationCitiesIdMutationResponse,
  DeleteApiV1LocationCitiesIdPathParams,
  DeleteApiV1LocationCitiesId401,
  DeleteApiV1LocationCitiesId404,
  DeleteApiV1LocationCitiesId500,
} from "../../types/locationCityController/DeleteApiV1LocationCitiesId.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { deleteApiV1LocationCitiesId } from "../../clients/locationCityController/deleteApiV1LocationCitiesId.ts";

export const deleteApiV1LocationCitiesIdMutationKey = () =>
  [{ url: "/api/v1/location/cities/:id" }] as const;

export type DeleteApiV1LocationCitiesIdMutationKey = ReturnType<
  typeof deleteApiV1LocationCitiesIdMutationKey
>;

export function deleteApiV1LocationCitiesIdMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const mutationKey = deleteApiV1LocationCitiesIdMutationKey();
  return mutationOptions<
    DeleteApiV1LocationCitiesIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1LocationCitiesId401
      | DeleteApiV1LocationCitiesId404
      | DeleteApiV1LocationCitiesId500
    >,
    { id: DeleteApiV1LocationCitiesIdPathParams["id"] },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id }) => {
      return deleteApiV1LocationCitiesId(id, config);
    },
  });
}

/**
 * @description Exclui permanentemente uma cidade. **(Requer Authorization para autenticação)**
 * @summary Excluir cidade (Requer Authorization para autenticação)
 * {@link /api/v1/location/cities/:id}
 */
export function useDeleteApiV1LocationCitiesId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiV1LocationCitiesIdMutationResponse,
      ResponseErrorConfig<
        | DeleteApiV1LocationCitiesId401
        | DeleteApiV1LocationCitiesId404
        | DeleteApiV1LocationCitiesId500
      >,
      { id: DeleteApiV1LocationCitiesIdPathParams["id"] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? deleteApiV1LocationCitiesIdMutationKey();

  const baseOptions = deleteApiV1LocationCitiesIdMutationOptions(
    config,
  ) as UseMutationOptions<
    DeleteApiV1LocationCitiesIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1LocationCitiesId401
      | DeleteApiV1LocationCitiesId404
      | DeleteApiV1LocationCitiesId500
    >,
    { id: DeleteApiV1LocationCitiesIdPathParams["id"] },
    TContext
  >;

  return useMutation<
    DeleteApiV1LocationCitiesIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1LocationCitiesId401
      | DeleteApiV1LocationCitiesId404
      | DeleteApiV1LocationCitiesId500
    >,
    { id: DeleteApiV1LocationCitiesIdPathParams["id"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiV1LocationCitiesIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1LocationCitiesId401
      | DeleteApiV1LocationCitiesId404
      | DeleteApiV1LocationCitiesId500
    >,
    { id: DeleteApiV1LocationCitiesIdPathParams["id"] },
    TContext
  >;
}
